import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { combineLatest, firstValueFrom } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AppState } from '../state/app.state';
import { loadTranslations } from '../admin/translations/state/translations.actions';
import {
  selectTranslationsForLang,
  selectTranslationsLoadFailed,
} from '../admin/translations/state/translations.selectors';
import { inject } from '@angular/core';
import { DsLoadingAreaService } from '@bmw-ds/components';

export const initTranslations = (
  translate: TranslateService,
  store: Store<AppState>
): (() => Promise<void>) => {
  const loadingAreaService = inject(DsLoadingAreaService);
  return async () => {
    loadingAreaService.addLoadingArea({
      backdropVariant: 'solid',
      id: 'loading-translations',
      loadingText: 'Please wait while data is loaded',
      loadingTitle: 'Loading translations',
    });
    store.dispatch(loadTranslations());

    try {
      const englishLoaded = await firstValueFrom(
        combineLatest([
          store.select(selectTranslationsForLang('en')),
          store.select(selectTranslationsLoadFailed),
        ]).pipe(
          filter(
            ([englishTable, loadFailed]) =>
              (!!englishTable && Object.keys(englishTable).length > 0) ||
              loadFailed
          ),
          take(1),
          map(
            ([englishTable]) =>
              !!englishTable && Object.keys(englishTable).length > 0
          )
        )
      );

      if (englishLoaded) {
        translate.setFallbackLang('en');
      }
    } finally {
      loadingAreaService.removeLoadingArea('loading-translations');
    }
  };
};
